import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { Flex, Icon, Text, Button, HStack } from '@chakra-ui/react'
import React, { useMemo, memo } from 'react'

export const Pagination = memo(({ page, setPage, limit, totalPages, isDisabled }) => {
  // Gerar array de páginas a serem exibidas
  const pageNumbers = useMemo(() => {
    const pages = []

    // Mostrar até 5 páginas
    if (totalPages <= 5) {
      // Se tiver 5 ou menos páginas, mostra todas
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      // Se tiver mais de 5 páginas, mostra seletivamente
      if (page <= 3) {
        // Se estiver nas primeiras páginas
        for (let i = 1; i <= 4; i++) {
          pages.push(i)
        }
        pages.push('...')
        pages.push(totalPages)
      } else if (page >= totalPages - 2) {
        // Se estiver nas últimas páginas
        pages.push(1)
        pages.push('...')
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i)
        }
      } else {
        // Se estiver no meio
        pages.push(1)
        pages.push('...')
        pages.push(page - 1)
        pages.push(page)
        pages.push(page + 1)
        pages.push('...')
        pages.push(totalPages)
      }
    }

    return pages
  }, [page, totalPages])

  function handleNextPage() {
    if (page < totalPages && !isDisabled) {
      setPage(page + 1)
    }
  }

  function handlePreviousPage() {
    if (page > 1 && !isDisabled) {
      setPage(page - 1)
    }
  }

  function handleGoToPage(pageNumber) {
    if (!isDisabled && pageNumber !== '...') {
      setPage(pageNumber)
    }
  }

  return (
    <Flex alignItems="center" justifyContent="center" gap={2}>
      <Icon
        as={ChevronLeftIcon}
        w={6}
        h={6}
        onClick={handlePreviousPage}
        borderRadius="50%"
        boxShadow="md"
        bg={page === 1 || isDisabled ? 'gray.100' : 'gray.200'}
        color={page === 1 || isDisabled ? 'gray.400' : 'gray.600'}
        _hover={page === 1 || isDisabled ? {} : { bg: 'gray.300', cursor: 'pointer' }}
        cursor={page === 1 || isDisabled ? 'not-allowed' : 'pointer'}
      />

      <HStack spacing={1}>
        {pageNumbers.map((pageNumber, index) => (
          <Button
            key={index}
            size="sm"
            variant={pageNumber === page ? 'solid' : 'outline'}
            colorScheme={pageNumber === page ? 'blue' : 'gray'}
            onClick={() => handleGoToPage(pageNumber)}
            isDisabled={isDisabled || pageNumber === '...'}
            cursor={pageNumber === '...' ? 'default' : 'pointer'}
            minW="32px"
          >
            {pageNumber}
          </Button>
        ))}
      </HStack>

      <Icon
        as={ChevronRightIcon}
        w={6}
        h={6}
        onClick={handleNextPage}
        borderRadius="50%"
        boxShadow="md"
        bg={page === totalPages || isDisabled ? 'gray.100' : 'gray.200'}
        color={page === totalPages || isDisabled ? 'gray.400' : 'gray.600'}
        _hover={page === totalPages || isDisabled ? {} : { bg: 'gray.300', cursor: 'pointer' }}
        cursor={page === totalPages || isDisabled ? 'not-allowed' : 'pointer'}
      />
    </Flex>
  )
})
